import { h } from 'preact'
import { useCallback } from "preact/hooks"
import { useAppState } from './appState'


export default function useSendHelpRequest() {
  const {
    takeAction,
    sendingHelpRequest,
    errorSendingHelpRequest,
    sentHelpRequest
  } = useAppState({
    'sendingHelpRequest': 'sendingHelpRequest',
    'errorSendingHelpRequest': 'errorSendingHelpRequest',
    'sentHelpRequest': 'sentHelpRequest'
  },
  'useSendHelpRequest'
  )

  const sendHelpRequest = useCallback(({ email, mobile, message, attachInfo }) => {
    takeAction('sendHelpRequest', { email, mobile, message, attachInfo })
  }, [takeAction])


  return {
    sendHelpRequest,
    sendingHelpRequest,
    errorSendingHelpRequest,
    sentHelpRequest,
  }
}
